// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import config from "../../config";
// import { Checkbox } from "primereact/checkbox";
// import { MultiSelect } from 'primereact/multiselect';

// function AddNewReview() {
//   const navigate = useNavigate();
//   const [error, setError] = useState(null);
//     const [formData, setFormData] = useState({
//       title: '',
//       description: '',
//       featuredImage: null,
//       clientname: '',
//     });
//      const handleInputChange = async (e) => {
//     const { name, value, files } = e;

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: files ? files : value
//     }));
//   };
//   const handleAddReview = async (e) => {
//     e.preventDefault();
//     const data = new FormData();
//     data.append('title', formData.title);
//     data.append('description', formData.description);
//     data.append('clientname', formData.clientname);

//     if (formData.featuredImage) {
//       data.append('featuredImage', formData.featuredImage[0]);
//     }

//     try {
//       const response = await axios.post(`${config.BASE_URL}/api/admin/add-review`, data, {
//         withCredentials: true,
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       if (response.status === 200) {
//         const token = localStorage.getItem('token');
//         if (token) {
//           navigate('/admin/reviews');
//         } else {
//           navigate('/admin/login');
//         }
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to add review');
//     }
//   };

//   return (
//     <div className="dashboard">
//       <div className="container">
//         <h1 className="dash_title">Dashboard</h1>
//         <div className="main-section">
//           <div className="back_btn_wrap">
//             <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//           </div>
//           <div className="main-inner add_project_main">
//             <form onSubmit={handleAddReview} encType="multipart/form-data">
//               <div className="form-login">
//                 <div className="add_field titleField">
//                   <h2>Title</h2>
//                   <input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>

//                 <div className="add_field textareaField">
//                   <h2>Description</h2>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>

//                 <div className="add_field">
//                   <h2>Featured Image</h2>
//                   <div className="form-group">
//                     <div className="file-upload">
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="featuredImage"
//                         onChange={(e) => handleInputChange(e.target)}
//                         required
//                       />
//                       <i className="fa fa-camera i-pic-upload"></i>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="add_field titleField">
//                   <h2>Client Name</h2>
//                   <textarea
//                     name="clientname"
//                     value={formData.clientname}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="add_project">
//                 <button type="submit">Add Review</button>
//               </div>
//             </form>
//             {error && <p className="error-message">{error}</p>}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AddNewReview;





import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function AddNewReview() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [activeLanguage, setActiveLanguage] = useState('en');

  // Main form data for English (default)
  const [formData, setFormData] = useState({
    language: 'en',
    title: '',
    description: '',
    clientname: '',
    // slug: '',
    featuredImage: null,
  });

  // Spanish translation data
  const [spanishData, setSpanishData] = useState({
    language: 'es',
    title: '',
    description: '',
    clientname: '',
  });

  // Handle language tab switching
  const switchLanguage = (lang) => {
    setActiveLanguage(lang);
  };

  // Main form handlers (English)
  const handleInputChange = async (e) => {
    const { name, value, files } = e;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : value
    }));
  };

  // Spanish form handlers
  const handleSpanishInputChange = (e) => {
    const { name, value } = e.target;
    setSpanishData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Form submission
  const handleAddReview = async (e) => {
    e.preventDefault();
    const data = new FormData();
    
    // Main English data
    data.append('language', formData.language);
    data.append('title', formData.title);
    data.append('description', formData.description);
    data.append('clientname', formData.clientname);
    // data.append('slug', formData.slug);

    // Spanish translation data
    data.append('spanishData', JSON.stringify(spanishData));
    
    // File upload (shared between languages)
    if (formData.featuredImage) {
      data.append('featuredImage', formData.featuredImage[0]);
    }

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/add-review`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/admin/reviews');
        } else {
          navigate('/admin/login');
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add review');
    }
  };

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Dashboard</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            
            {/* Language Tabs */}
            <div className="language-tabs" style={{ marginBottom: '20px' }}>
              <button 
                type="button" 
                className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                onClick={() => switchLanguage('en')}
                style={{
                  padding: '10px 20px',
                  marginRight: '10px',
                  backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'en' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                English
              </button>
              <button 
                type="button" 
                className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                onClick={() => switchLanguage('es')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'es' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                Spanish
              </button>
            </div>

            <form onSubmit={handleAddReview} encType="multipart/form-data">
              
              {/* English Content */}
              {activeLanguage === 'en' && (
                <div className="language-content">
                  <h3>English Content</h3>
                  
                  <div className="form-login">
                    <div className="add_field titleField">
                      <h2>Title (English)</h2>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                    </div>

                    {/* <div className="add_field titleField">
                      <h2>Slug (English)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        onChange={(e) => handleInputChange(e.target)}
                        placeholder="url-friendly-slug"
                        required
                      />
                    </div> */}

                    <div className="add_field textareaField">
                      <h2>Description (English)</h2>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={(e) => handleInputChange(e.target)}
                        rows="4"
                        placeholder="Enter review description"
                        required
                      />
                    </div>

                    <div className="add_field titleField">
                      <h2>Client Name (English)</h2>
                      <input
                        type="text"
                        name="clientname"
                        value={formData.clientname}
                        onChange={(e) => handleInputChange(e.target)}
                        placeholder="Enter client name"
                        required
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Spanish Content */}
              {activeLanguage === 'es' && (
                <div className="language-content">
                  <h3>Spanish Content</h3>
                  
                  <div className="form-login">
                    <div className="add_field titleField">
                      <h2>Title (Spanish)</h2>
                      <input
                        type="text"
                        name="title"
                        value={spanishData.title}
                        onChange={handleSpanishInputChange}
                        placeholder="Título en español"
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Description (Spanish)</h2>
                      <textarea
                        name="description"
                        value={spanishData.description}
                        onChange={handleSpanishInputChange}
                        rows="4"
                        placeholder="Ingrese la descripción de la reseña"
                      />
                    </div>

                    <div className="add_field titleField">
                      <h2>Client Name (Spanish)</h2>
                      <input
                        type="text"
                        name="clientname"
                        value={spanishData.clientname}
                        onChange={handleSpanishInputChange}
                        placeholder="Ingrese el nombre del cliente"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Shared Fields - Always Visible */}
              <div className="shared-fields">
                <div className="add_field">
                  <h2>Featured Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="featuredImage"
                        onChange={(e) => handleInputChange(e.target)}
                        accept="image/*"
                        required
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                  <small style={{ color: '#666', fontSize: '12px' }}>
                    This image will be shared across all language versions
                  </small>
                </div>
              </div>

              <div className="add_project">
                <button type="submit">Add Review</button>
              </div>

            </form>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewReview;
